export const Pages = {
  settings: "settings",
  appointment: "appointment",
  property: "property",
  clients: "clients",
  staff: "staff",
  roles: "roles",
  vouchers: "vouchers",
  receipt: "receipt",
  expenditure: "expenditure",
  dashboard: "dashboard",
  subscriptions: "subscriptions",
  cashflow: "cashflow",
  commission: "commission",
  marketers: "marketers",
};

export const AccessLevels = ["read", "write", "delete"];
